import React from 'react';
import {Box} from '@material-ui/core';
//import { LoadingButton } from '@mui/lab';
import {MetaTags} from 'react-meta-tags';
// import TextField from '@mui/material/TextField';
// import InputLabel from '@mui/material/InputLabel';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
// import MenuItem from '@mui/material/MenuItem';
// import Stack from '@mui/material/Stack';
// import Snackbar from '@mui/material/Snackbar';
// import Alert from '@mui/material/Alert';
// import axios from 'axios';
// import {API_URL} from '../utils/EnvVars';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import '../styles/bizofficer-a.css';
  
const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

  export default function Execute(props) {
	// check if logged in
	if(localStorage.getItem('etlStudentObj')===null){
		window.location.href='login';
	}
	const classes = useStyles();

	
	
	  function getVoices() {
			let voices = speechSynthesis.getVoices();
			if(!voices.length){
			// some time the voice will not be initialized so we can call speak with empty string
			// this will initialize the voices 
			let utterance = new SpeechSynthesisUtterance("");
			speechSynthesis.speak(utterance);
			voices = speechSynthesis.getVoices();
	  }
	  
	  
	  function speak(text, voice, rate, pitch, volume) {
		// create a SpeechSynthesisUtterance to configure the how text to be spoken 
		let speakData = new SpeechSynthesisUtterance();
		speakData.volume = volume; // From 0 to 1
		speakData.rate = rate; // From 0.1 to 10
		speakData.pitch = pitch; // From 0 to 2
		speakData.text = text;
		speakData.lang = 'en';
		speakData.voice = voice;
		
		// pass the SpeechSynthesisUtterance to speechSynthesis.speak to start speaking 
		speechSynthesis.speak(speakData);
	  
	  }
	  
	  if ('speechSynthesis' in window) {
		let voices = getVoices();
		let rate = 1, pitch = 2, volume = 1;
		let text = "Spaecking with volume = 1 rate =1 pitch =2 ";
		
		speak(text, voices[5], rate, pitch, volume);

		rate = 0.5; 
		pitch = 1.5;
		volume = 0.5;
		text = "Spaecking with volume = 0.5 rate = 0.5 pitch = 1.5 ";

		setTimeout(()=>{ // speak after 2 seconds 
			speak(text, voices[10], rate, pitch, volume );
		}, 2000);

	  }else{
	  	console.log(' Speech Synthesis Not Supported'); 
	  }

	  }



	return (
		<div> 
				<MetaTags>
            		<title>Feedback</title>
          		</MetaTags>
				
				  <Header />	
	   			  <LeftDrawer />
				<main className={classes.content}>  
				
				<Box style={{marginBottom:100, marginLeft:20, marginRight:20}}>	

					<Box mt={1}>

      <div id="content"></div>
      <button id="speakButton">Click to Speak</button>
      <script>
      </script>


					</Box>
				</Box>
				</main>			


		</div>	
	);
  }